import React, { useMemo } from 'react'
import { Button } from '../buttons'
import { ErrorState } from '../Types'
import classNames from "classnames";

export interface NextPreviousProps {
    className?: string
    next?: string | JSX.Element | null
    onNext?: () => any
    previous?: string | JSX.Element | null
    onPrevious?: () => any
    errors?: ErrorState<any> | boolean
}

export const NextPrevious: React.FC<NextPreviousProps> = (props) => {
    const errors = useMemo(() =>{

        if(typeof props.errors == "object") {
            return Object.keys(props.errors).length > 0;
        }
        else {
            return props.errors ? true : false;
        }
    }, [props.errors]);

    return (
        <div className={classNames("row", props.className)}>
            <div className="col-3">
                {props.previous === null ? <></> : <Button
                    className='float-left'
                    label={props.previous || "Previous"}
                    disabled={props.onPrevious ? undefined : true}
                    onClick={() => { props.onPrevious && props.onPrevious() }}
                />}
            </div>
            <div className="col-6 text-center text-danger">
                {errors && <div id="next-hint" className='ml-2'><i className="fas fa-exclamation-triangle"></i> Please complete the required fields</div>}
            </div>
            <div className="col-3">
                {props.next === null ? <></> : <Button
                    id='next-summary'
                    label={props.next || "Next"}
                    disabled={props.onNext ? undefined : true}
                    onClick={() => { props.onNext && props.onNext() }}
                    className="float-right"
                    describedBy={errors ? "next-hint": ''}
                />}
            </div>
        </div>)
}